var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.086,
    height: 85.086,
    viewBox: "0 0 85.086 85.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(-160 -912)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 42.543,
    cy: 42.543,
    r: 42.543,
    transform: "translate(160 912)",
    fill: "#9ad2b0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(184.354 935.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pencil-alt",
    "data-name": "Icon awesome-pencil-alt",
    d: "M37.987,10.841,34.47,14.358a.916.916,0,0,1-1.3,0L24.7,5.889a.916.916,0,0,1,0-1.3l3.517-3.517a3.67,3.67,0,0,1,5.18,0l4.585,4.585A3.656,3.656,0,0,1,37.987,10.841Zm-16.3-3.227L1.648,27.649.03,36.918a1.833,1.833,0,0,0,2.121,2.121l9.27-1.625L31.456,17.379a.916.916,0,0,0,0-1.3L22.987,7.614a.926.926,0,0,0-1.3,0ZM9.468,25.932a1.064,1.064,0,0,1,0-1.511L21.217,12.672a1.068,1.068,0,0,1,1.511,1.511L10.979,25.932a1.064,1.064,0,0,1-1.511,0ZM6.714,32.348h3.662v2.769l-4.921.862L3.082,33.607l.862-4.921H6.714Z",
    transform: "translate(-0.002 -0.005)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilGreen);
export default __webpack_public_path__ + "static/media/pencil-green.ca27667c4c0fd6b50189af0c39462dc0.svg";
export { ForwardRef as ReactComponent };